// One sync of the integrator's history: date · job · concept · status · detail.
// The detail column tells the row's story — the posting reference of a synced row,
// the error of a failed one. RETRY shows only on errored rows: the deliberate human
// action after the failure is fixed.
class IntegratorHistoryCell extends UITableViewCell
{
    private dateLabel: MUILabel = null;
    private jobLabel: MUILabel = null;
    private conceptLabel: MUILabel = null;
    private statusLabel: MUILabel = null;
    private detailLabel: MUILabel = null;
    private retryButton: MUIButton = null;

    awakeFromHTML() {
        this.dateLabel = MUIOutlet(this, "date-lbl", "MUILabel");
        this.jobLabel = MUIOutlet(this, "job-lbl", "MUILabel");
        this.conceptLabel = MUIOutlet(this, "concept-lbl", "MUILabel");
        this.statusLabel = MUIOutlet(this, "status-lbl", "MUILabel");
        this.detailLabel = MUIOutlet(this, "detail-lbl", "MUILabel");

        this.retryButton = MUIOutlet(this, "retry-btn", "MUIButton");
        this.retryButton.setAction(this, function(this:IntegratorHistoryCell) {
            if (this.onRetry != null && this._sync != null) this.onRetry(this._sync);
        });

        this.selectionStyle = UITableViewCellSelectionStyle.None;
    }

    onRetry: any = null;
    private _sync: any = null;

    set item(sync: any) {
        this._sync = sync;

        this.dateLabel.text = sync["date"] ?? "";
        let job = sync["job"] ?? "?";
        this.jobLabel.text = sync["kind"] != null ? job + " · " + sync["kind"] : job;
        this.conceptLabel.text = sync["concept"] ?? "";

        let status = sync["status"];
        let error = status == -1;
        this.statusLabel.text = error ? MIOLocalizeString("ERROR", "ERROR")
                              : status == 2 ? MIOLocalizeString("SYNCED", "SYNCED")
                              : status == 1 ? MIOLocalizeString("IN_QUEUE", "IN QUEUE")
                              : MIOLocalizeString("PENDING", "PENDING");
        this.statusLabel.layer.classList.toggle("status-error", error);
        this.statusLabel.layer.classList.toggle("status-synced", status == 2);

        // The detail tells the whole story: the posting reference, plus WHAT was sent
        // (a claim's posted lines: code + amount) or what WOULD be sent (a held
        // production row's category preview under the current matrix).
        let detail = sync["reference"] ?? "";
        let posted = sync["posted"];
        if (posted instanceof Array && posted.length > 0) {
            let parts = posted.map(function(p){ return p["code"] + " " + p["amount"]; });
            detail = (detail.length > 0 ? detail + "  ·  " : "") + parts.join(" · ");
        }
        let cats = sync["categories"];
        if (cats != null) {
            let parts = Object.keys(cats).sort().map(function(k){ return k + " " + cats[k]; });
            if (parts.length > 0) detail = (detail.length > 0 ? detail + "  ·  " : "") + parts.join(" · ");
        }
        this.detailLabel.text = error ? (sync["error"] ?? "") : detail;
        this.retryButton.setHidden(!error);
    }
}
